<template>
  <div>
    <div
      class="side-menu-overlay"
      v-on:click="closeMenu"
      v-bind:class="{ active: isActive }"
    ></div>
    <div
      class="side-menu-wrapper"
      v-bind:class="{ isRight: isRight, active: isActive }"
    >
      <div class="menu-content" v-bind:class="{ isRight: isRight}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    closeMenu: {
      type: Function,
    },
    isRight: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {};
  },
  watch: {
    isActive: function(val){
        const body = document.getElementsByTagName('body')[0];

        if(val) body.style.overflow = 'hidden'
        else body.style.overflow = ''
    }
  }
};
</script>

<style lang="scss">
.side-menu-overlay {
  /* overlay */
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 2001;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  opacity: 0;
  transition: opacity 1s;
  &.active {
    width: 100%;
    opacity: 1;
  }
}
.side-menu-wrapper {
  /* style menu wrapper */
  overflow: hidden;
  position: fixed; /* Fixed position */
  top: 0;
  left: -100%; /* Sidebar initial position. "right" for right positioned menu */
  height: 100%;
  z-index: 2002;
  transition: 0.5s; /* CSS transition speed */
  width: 100%;
  display: flex;
  flex-direction: row-reverse;

  &.active {
    left: 0;
  }
  &.isRight {
    right: -100%;
    flex-direction: row;

    &.active {
      right: 0;
      left: initial;
    }
  }

  .menu-content {
    width: 100%;
    background: white;
    overflow-y: scroll;
    &.isRight{
        text-align: right;
    }
  }
  a:hover {
    text-decoration: none;
  }
  
}
</style>
